import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { brl, fmtDate } from "@/lib/api";

const TONE = { Ativo: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400", "Em teste": "bg-blue-500/15 text-blue-600 dark:text-blue-400", Inativo: "bg-muted text-muted-foreground" };

function Empty({ text }) {
  return <p className="px-5 py-8 text-center text-sm text-muted-foreground">{text}</p>;
}

export function ReferralsList({ rows }) {
  return (
    <div className="card-surface overflow-x-auto" data-testid="referral-referrals">
      <p className="eyebrow px-5 pt-5">Suas indicações</p>
      {!rows.length ? <Empty text="Nenhuma indicação ainda. Compartilhe seu link para começar." /> : (
        <Table>
          <TableHeader><TableRow><TableHead>Cliente</TableHead><TableHead>Desde</TableHead><TableHead>Situação</TableHead><TableHead className="text-right">Comissões geradas</TableHead></TableRow></TableHeader>
          <TableBody>{rows.map((r, i) => (
            <TableRow key={i} data-testid={`referral-row-${i}`}>
              <TableCell className="font-medium">{r.name}</TableCell><TableCell>{fmtDate(r.since)}</TableCell>
              <TableCell><span className={`rounded-full px-2 py-0.5 text-xs font-medium ${TONE[r.status]}`}>{r.status}</span></TableCell>
              <TableCell className="text-right font-mono">{brl(r.commission)}</TableCell>
            </TableRow>
          ))}</TableBody>
        </Table>
      )}
    </div>
  );
}

export function PayoutsList({ rows }) {
  return (
    <div className="card-surface overflow-x-auto" data-testid="referral-payouts">
      <p className="eyebrow px-5 pt-5">Histórico de pagamentos</p>
      {!rows.length ? <Empty text="Nenhum fechamento ainda. As comissões entram aqui no fim de cada período." /> : (
        <Table>
          <TableHeader><TableRow><TableHead>Período</TableHead><TableHead>Comissões</TableHead><TableHead>Valor</TableHead><TableHead>Situação</TableHead></TableRow></TableHeader>
          <TableBody>{rows.map((p) => (
            <TableRow key={p.id} data-testid={`referral-payout-${p.id}`}>
              <TableCell>{p.period_label}</TableCell><TableCell>{p.count}</TableCell><TableCell className="font-mono">{brl(p.amount)}</TableCell>
              <TableCell>{p.status === "paid" ? <Badge className="bg-emerald-600 hover:bg-emerald-600">Pago em {fmtDate(p.paid_at)}</Badge> : <Badge variant="outline">Aguardando pagamento</Badge>}</TableCell>
            </TableRow>
          ))}</TableBody>
        </Table>
      )}
    </div>
  );
}
